module.exports = __webpack_public_path__ + "static/media/excitement.92258a0e.svg";